import React from 'react';

export const RemitoDetalle = React.forwardRef(({ movimiento, producto }, ref) => {
    if (!producto) return null;
    const esSalida = movimiento.type === 'salida';

    return (
        <div ref={ref} className="p-12 bg-white text-gray-800" style={{ width: '210mm', minHeight: '297mm' }}>
            {/* Encabezado con Logo */}
            <div className="flex justify-between items-center border-b-4 border-gray-900 pb-6 mb-8">
                <div className="flex items-center gap-4">
                    {/* Reemplaza esta URL por la de tu logo local o web */}
                    <img 
                    src="/imagenes/sinfondo.png" 
                    alt="Logo de la empresa" 
                    className="max-w-[230px] h-auto object-contain"
                    />
                    <div>
                        <h1 className="text-2xl font-black uppercase">Remito de Movimiento</h1>
                        <p className="text-xs tracking-widest text-gray-500">CONTROL DE INVENTARIO</p>
                    </div>
                </div>
                <div className="text-right">
                    <p className="font-bold">{new Date().toLocaleDateString()}</p>
                    <p className="text-sm text-gray-500">{new Date().toLocaleTimeString()}</p>
                </div>
            </div>

            {/* Info Movimiento */}
            <div className={`p-6 rounded-2xl mb-8 border-2 ${esSalida ? 'bg-red-50 border-red-100' : 'bg-green-50 border-green-100'}`}>
                <div className="grid grid-cols-2 gap-4">
                    <p><strong>Tipo:</strong> <span className="uppercase font-black">{movimiento.type}</span></p>
                    <p><strong>Destino:</strong> {movimiento.destino}</p>
                    <p><strong>Receptor:</strong> {movimiento.receptor}</p>
                    <p><strong>Cantidad:</strong> {movimiento.quantity} unidades</p>
                </div>
            </div>

            {/* Detalle Producto */}
            <table className="w-full mb-10">
                <thead>
                    <tr className="bg-gray-100 text-left uppercase text-xs">
                        <th className="p-3">Código</th>
                        <th className="p-3">Descripción</th>
                    </tr>
                </thead>
                <tbody>
                    <tr className="border-b">
                        <td className="p-3 font-mono">{producto.codigo}</td>
                        <td className="p-3">{producto.descripcion}</td>
                    </tr>
                </tbody>
            </table>

            <div className="mb-20">
                <p className="text-xs font-bold uppercase mb-2">Observaciones:</p>
                <p className="italic text-gray-600">{movimiento.observacion || "Sin detalles adicionales."}</p>
            </div>

            <div className="grid grid-cols-2 gap-20 mt-32 text-center text-xs font-bold uppercase">
                <div className="border-t border-gray-400 pt-2">Firma Entrega</div>
                <div className="border-t border-gray-400 pt-2">Firma Recepción</div>
            </div>
        </div>
    );
});